import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/config`;

/**
 * GET
 */

export const getStates = async () => {
  const url = `${baseRoute}/state`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getStateOptions = async () => {
  const url = `${baseRoute}/stateOptions`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

/**
 *
 * @param {*} opts
 *  stateid
 *  cityname
 */
export const getCities = async (opts = {}) => {
  const q = queryString.stringify(opts);
  const url = `${baseRoute}/city?${q}`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};
